import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { PUT_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import {
  UpdateTagPayload,
  TagResponse
} from '@utils/types/organization/tag.ts';

interface UpdateTagParams {
  tagId: number;
  payload: UpdateTagPayload;
}

const putTag = async ({
  tagId,
  payload
}: UpdateTagParams): Promise<TagResponse> => {
  const { data } = await Axios.put<TagResponse>(
    PUT_URL(String(tagId)).updateTag,
    payload
  );
  return data;
};

export const useUpdateTag = () => {
  const queryClient = useQueryClient();

  return useMutation<TagResponse, AxiosError<BaseError>, UpdateTagParams>(
    putTag,
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries(['tags']);
        queryClient.invalidateQueries(['tag', variables.tagId]);
        queryClient.invalidateQueries(['tagAssignments']);
      },
      useErrorBoundary: false
    }
  );
};
